import React from "react";
import AllocationRuleFormModal from "@features/admin/finance/allocation-rule/components/AllocationRuleFormModal";

const CreateAllocationRuleModal: React.FC<{ show: boolean; onHide: () => void; onChanged?: () => void }> = ({ show, onHide, onChanged }) => (
    <AllocationRuleFormModal
        show={show}
        onHide={onHide}
        rule={null}
        onSaved={onChanged}
        testId="create-allocation-rule-modal"
    />
);

export default CreateAllocationRuleModal;
